import styled from 'styled-components';

import { SmallParagraph } from '@genially/design-system';
import { FilterIcon, SuccessIcon } from '@genially/icons';

export const Wrapper = styled.div({
  flexShrink: 0,
});

export const Trigger = styled.button(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
  padding: 0,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
}));

export const TriggerLabel = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const StyledFilterIcon = styled(FilterIcon)(({ theme: { color, size } }) => ({
  width: size.units(2),
  height: size.units(2),
  flexShrink: 0,
  color: color.content.reversed.default(),
}));

export const StyledSuccessIcon = styled(SuccessIcon)(({ theme: { color, size } }) => ({
  width: size.units(1.75),
  height: size.units(1.75),
  color: color.content.accent.default(),
}));
